import { OptionPicker } from '@vfde-brix/ws10/option-picker';
import {
    RedTariff,
    YoungTariff,
} from '@vfde-sails/constants';

/**
 * Get available subscription IDs from tariff picker element
 */
const getAvailableSubscriptionIds = (optionPicker: OptionPicker | null): Array<RedTariff | YoungTariff> => {
    if (!optionPicker) {
        return [];
    }

    return optionPicker.getAllPossibleValues();
};

export default getAvailableSubscriptionIds;
